
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/personal/recruitment",
      function () {
        return require("private-next-pages/personal/recruitment/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/personal/recruitment"])
      });
    }
  